/**
 * @generated SignedSource<<fea25979bd296e392aa74fa863905300>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type webFormSubmissionsUtils_useCountQuery$variables = {
  completed?: boolean | null;
  contentUsageId?: string | null;
  excludeUsageScope?: boolean | null;
  include: boolean;
  membersOnly?: boolean | null;
  passed?: boolean | null;
  uniqueByMember?: boolean | null;
  webFormId: string;
};
export type webFormSubmissionsUtils_useCountQuery$data = {
  readonly node?: {
    readonly __typename: "WebForm";
    readonly id: string;
    readonly submissionsCount: number;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type webFormSubmissionsUtils_useCountQuery = {
  response: webFormSubmissionsUtils_useCountQuery$data;
  variables: webFormSubmissionsUtils_useCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentUsageId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeUsageScope"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "include"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membersOnly"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "passed"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uniqueByMember"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "webFormId"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "webFormId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "completed",
      "variableName": "completed"
    },
    {
      "kind": "Variable",
      "name": "contentUsageId",
      "variableName": "contentUsageId"
    },
    {
      "kind": "Variable",
      "name": "excludeUsageScope",
      "variableName": "excludeUsageScope"
    },
    {
      "kind": "Variable",
      "name": "membersOnly",
      "variableName": "membersOnly"
    },
    {
      "kind": "Variable",
      "name": "passed",
      "variableName": "passed"
    },
    {
      "kind": "Variable",
      "name": "uniqueByMember",
      "variableName": "uniqueByMember"
    }
  ],
  "kind": "ScalarField",
  "name": "submissionsCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "webFormSubmissionsUtils_useCountQuery",
    "selections": [
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "type": "WebForm",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "webFormSubmissionsUtils_useCountQuery",
    "selections": [
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/)
                ],
                "type": "WebForm",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9057a9aa025a5c155eac1f7b2ff17463",
    "id": null,
    "metadata": {},
    "name": "webFormSubmissionsUtils_useCountQuery",
    "operationKind": "query",
    "text": "query webFormSubmissionsUtils_useCountQuery(\n  $webFormId: ID!\n  $include: Boolean!\n  $contentUsageId: ID\n  $excludeUsageScope: Boolean\n  $uniqueByMember: Boolean\n  $completed: Boolean\n  $passed: Boolean\n  $membersOnly: Boolean\n) {\n  node(id: $webFormId) @include(if: $include) {\n    __typename\n    ... on WebForm {\n      __typename\n      id\n      submissionsCount(contentUsageId: $contentUsageId, excludeUsageScope: $excludeUsageScope, uniqueByMember: $uniqueByMember, completed: $completed, passed: $passed, membersOnly: $membersOnly)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "65bc048d067a7659dbab7484aadf3d77";

export default node;
